export default function getRefreshToken(state) {
  if (state.loginForm && state.loginForm.refreshToken) {
    return state.loginForm.refreshToken;
  }
}